import { type Sort } from "@/features/status/components/sort-button";

const SportsQueryKeys = {
  global: ["sports"] as const,

  /**
   * Sports Categories
   */
  categories: () => [...SportsQueryKeys.global, "categories"] as const,

  /**
   * Live sports by sport type (or all)
   */
  live: (sportType = "all", subcategory = "all", limit = 20) =>
    [
      ...SportsQueryKeys.global,
      "live",
      sportType,
      subcategory,
      String(limit),
    ] as const,

  /**
   * Upcoming sports by sport type (or all)
   */
  upcoming: (sportType = "all", subcategory = "all", limit = 20) =>
    [
      ...SportsQueryKeys.global,
      "upcoming",
      sportType,
      subcategory,
      String(limit),
    ] as const,
};

const GameQueryKeys = {
  global: ["sportGames"] as const,

  details: (sportType: string, gameId: string) =>
    [...GameQueryKeys.global, sportType, gameId] as const,

  stats: (sportType: string, gameId: string) =>
    [...GameQueryKeys.global, sportType, gameId, "stats"] as const,

  plays: (sportType: string, gameId: string) =>
    [...GameQueryKeys.global, sportType, gameId, "plays"] as const,
};

const TeamQueryKeys = {
  global: ["sportTeams"] as const,

  details: (sportType: string, teamId: string) =>
    [...TeamQueryKeys.global, sportType, teamId] as const,

  news: (sportType: string, teamId: string) =>
    [...TeamQueryKeys.global, sportType, teamId, "news"] as const,

  games: (sportType: string, teamId: string) =>
    [...TeamQueryKeys.global, sportType, teamId, "games"] as const,

  players: (sportType: string, teamId: string) =>
    [...TeamQueryKeys.global, sportType, teamId, "players"] as const,

  stats: (sportType: string, teamId: string) =>
    [...TeamQueryKeys.global, sportType, teamId, "stats"] as const,
};

const NewsQueryKeys = {
  global: ["news"] as const,

  list: (sportType = "all", subcategory = "all", limit = 20) =>
    [
      ...NewsQueryKeys.global,
      "list",
      sportType,
      subcategory,
      String(limit),
    ] as const,

  detail: (newsId: string) =>
    [...NewsQueryKeys.global, "detail", newsId] as const,

  comments: (newsId: string, sort: Sort) =>
    [...NewsQueryKeys.global, newsId, "comments", sort] as const,
};

export { SportsQueryKeys, GameQueryKeys, TeamQueryKeys, NewsQueryKeys };
